import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { errorDispatch } from "../../../functions/errorDispatch";
import i18next from "../../../functions/i18next";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      mySpace: 0,
      name: "",
      description: "",
      color: "",
      isprivate: null,
      sort: "",
      target: 0,
      company: this.$store.state.company,
      user: this.$store.state.user,
    };
  },
  watch: {
    name() {
      this.name = this.name.replace("/", "_");
      this.name = this.name.replace("/", "_");
      this.name = this.name.replace(":", "_");
      this.name = this.name.replace("*", "_");
      this.name = this.name.replace("?", "_");
      this.name = this.name.replace("<", "_");
      this.name = this.name.replace(">", "_");
      this.name = this.name.replace("|", "_");
    },
  },
  created() {
    if (this.target != this.item.id) {
      this.target = this.item.id;
      this.sort = this.item.type
        ? this.item.type
        : this.item.extension
        ? "file"
        : "folder";
      this.name = this.item.name;
      //this.description = data[3];
      this.color = this.item.color;
      this.isprivate = this.item.isprivate;
      this.mySpace = this.item.myspace;
    }

    setTimeout(() => {
      if (this.$refs.name) {
        this.$refs.name.focus();
      }
    }, 300);
  },
  methods: {
    update() {
      let formData = new FormData();

      if (this.sort == "collection") {
        formData.append("collectionid", this.target);
        formData.append("name", this.name);

        this.$axios
          .post(`${baseUrl}/collectionedit`, formData)
          .then((r) => {
            //update name
            EventBus.$emit("closeallactions");

            EventBus.$emit(`collection-tree-update`);
          })
          .catch((e) => {
            errorDispatch(i18next.t("error.rename_collection"));
          });
      }

      if (this.sort == "folder") {
        formData.append("foldername", this.name);
        formData.append("foldertoupdate", this.target);
        formData.append("myspace", this.mySpace);

        this.$axios
          .post(baseUrl + "/folderupdate", formData)
          .then((response) => {
            EventBus.$emit("closeallactions");
            //refresh folders
            EventBus.$emit(`desktop-files-update`);
            EventBus.$emit(`tree-overview-reset`);
          });
      }
      if (this.sort == "file") {
        formData.append("file", this.name);
        formData.append("filetoupdate", this.target);
        formData.append("myspace", this.mySpace);

        this.$axios.post(baseUrl + "/filerename", formData).then((response) => {
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        });
      }
      if (this.sort == "space") {
        formData.append("foldertoupdate", this.target);
        formData.append("foldername", this.name);
        formData.append("description", this.description);
        formData.append("color", this.color);
        formData.append("private", this.isprivate);
        formData.append("myspace", this.mySpace);

        this.$axios
          .post(baseUrl + "/folderupdate", formData)
          .then((response) => {
            EventBus.$emit("closeallactions");
            //refresh folders
            EventBus.$emit(`desktop-files-update`);
            EventBus.$emit(`tree-overview-reset`);
          });
      }
    },
  },
};
